import { modalActionCreators } from '@opengov/component-library-classic/module/modals';
import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { EReportChartType } from '@opengov/reporting-types';

import { reportTargetActionCreators } from '../../../../../module/state';
import { reportLocaleText } from '../../../../common/locale';
import { ReportModalTypes } from '../../../../common/modals/types';
import { selectChartType, selectTarget } from '../../../../common/reportConfiguration/selectors';
import { IAnalysisControlsProps } from '../AnalysisControls';

export const selectHasReportTarget = createSelector(selectTarget, (target) => {
  return !!(target && target.elseStatus && target.conditions.length > 0);
});

export const selectAnalysisControlsProps = createStructuredSelector<any, IAnalysisControlsProps>({
  reportText: reportLocaleText,
  addTargetDisabled: createSelector(selectChartType, (chartType) => chartType === EReportChartType.Pie),
  hasTarget: selectHasReportTarget,
  onAddTargetButtonClick: () => () => modalActionCreators.setModalComponentType(ReportModalTypes.SET_TARGET),
  onEditTargetButtonClick: createSelector(selectTarget, (target) => () => {
    const hasTarget = !!(target && target.elseStatus && target.conditions.length > 0);
    if (hasTarget) {
      const firstCondition = target.conditions[0];
      reportTargetActionCreators.updateConditionOperator(firstCondition.operator);
      reportTargetActionCreators.updateConditionStatusText(firstCondition.status.text);
      reportTargetActionCreators.updateConditionValue(firstCondition.value);
      reportTargetActionCreators.updateElseStatusText(target.elseStatus.text);
      const secondCondition = target.conditions[1];
      if (secondCondition) {
        reportTargetActionCreators.updateSecondConditionStatusText(secondCondition.status.text);
        reportTargetActionCreators.updateSecondConditionValue(secondCondition.value);
      }
    }
    modalActionCreators.setModalComponentType(ReportModalTypes.SET_TARGET);
  })
});
